<template>
  <div class="df-container df-toast" v-if="value">
    <div class="mask"></div>
    <div class="toast" :class="{none:type == 'none'}">
      <i class="iconfont" :class="type"></i>
      <div class="text">{{info.content}}</div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'toast',
    data: function () {
      return {}
    },
    props: [
      'value',
      'info',
    ],
    computed: {
      type() {
        let type = "";
        switch (this.info.type) {
          case "success":
            type = "icon-roundcheck";
            break;
          case "fail":
            type = "icon-roundclose";
            break;
          case "none":
            type = "none";
            break;
        }
        return type

      },
      duration() {
        return this.info.duration
      }
    },
    created() {

    },
    mounted() {
      setTimeout(() => {
        this.$emit("on-hide")
      }, this.duration)
    },
    watch: {},
    methods: {},
  }
</script>
<style lang="scss" scoped type="text/scss">
  @import "css/common";

  .mask {
    opacity: 0;
  }

  .df-toast {
    .toast {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      padding: 20px 50px;
      background-color: #000;
      opacity: 0.6;
      color: #fff;
      border-radius: 10px;
      &.none {
        padding: 15px;
        .text {
          width: 300px;
          margin-top: 0;
        }
      }
      i {
        font-size: 80px;
      }
      .text {
        width: 200px;
        line-height: 35px;
        margin-top: 10px;
        font-size: 28px;
        text-align: center;
      }
    }
  }
</style>
